import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-error',
  templateUrl: './password-error.component.html',
  styleUrls: ['./password-error.component.scss'],
})
export class PasswordErrorDialogComponent implements OnInit {
  public text: string;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<PasswordErrorDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.text = data ? data.text : this.translate.instant('dialog.password.error');
  }

  ngOnInit(): void {
    // do nothing
  }

  cancel(): void {
    this.dialogRef.close({ logout: false });
  }

  public accept(): void {
    this.dialogRef.close({ logout: true });
  }
}
